export default "__VITE_ASSET__CgVTdsDb__"